export interface ISignatureDTO {
    /**
     * identifikátor záznamu
     */
    instanceID: string;

    /**
     * Digitální podpis vytvořený na klientské straně nebo null, pokud je podpis v objektu
     */
    signature: string;

    /**
     * Podepisovaná data v textové podobě
     */
    signedData: string;
}

export interface ISignaturesDataDTO {
    /**
    * Kolekce podepsaných objektů
    */
    signatures: ISignatureDTO[];

    /**
    * ID podpisového provideru
    */
    profileId: string;

    /**
    * Typ podpisového provideru
    */
    providerType: string;

    /**
    * Verze podpisového provideru
    */
    providerVersion: string;
}

export interface ISignatureDataDTO {
    /**
      * Digitální podpis
      */
    signature: string;

    /**
     * Podepisovaná data v textové podobě
     */
    signedData: string;

    /**
    * ID podpisového provideru
    */
    profileId: string;

    /**
    * Typ podpisového provideru
    */
    providerType: string;

    /**
    * Verze podpisového provideru
    */
    providerVersion: string;
}
